import { BaseService } from './base.service'

import axios from '@axios'
import { ResponseWrapper, ErrorWrapper } from './util'

export class RoleService extends BaseService {
  static get entity () {
    return '/role/page'
  }

  static async findAll (parameters = {}) {

    const params = { ...parameters }

    try {
      const response = await axios.get(`${this.entity}`, { params })

      // NOT FOUND
      if (response.data.code == '06') {
        const message = response.data.message
        errorNotification(Vue, "Oops!", message);
        throw new ErrorWrapper(error, message)
      }

      const data = {
        content: response.data.data.content,
        total: Number(response.data.data.totalElements)
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }

  static async create (data = {}) {
    try {
      const response = await axios.post(`/role`, data, {
        headers: { "content-type": "application/json" },
      })

      if (response.data.code == '02') {
        const message = response.data.message
        throw message
      }

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error
      throw new ErrorWrapper(error, message)
    }
  }

  static async update (id, data) {

    try {
      const response = await axios.put(`/role/${id}`, data, {
        headers: { "content-type": "application/json" },
      })

      if (response.data.code == '02') {
        const message = response.data.message
        throw message
      }

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error
      throw new ErrorWrapper(error, message)
    }
  }
}
